<template>
  <nav
    :class="[$vnode.data.class, $vnode.data.staticClass, 'sf-breadcrumbs']"
    :style="[$vnode.data.style, $vnode.data.staticStyle]"
    v-bind="$vnode.attrs"
    aria-label="breadcrumb"
  >
    <ol class="sf-breadcrumbs__list">
      <li
        v-for="(breadcrumb, i) in breadcrumbs"
        :key="i"
        class="sf-breadcrumbs__list-item"
        :aria-current="
          breadcrumbLast(breadcrumbs) === i && 'page'
        "
        @click="eventCustomlinksInteracted({
          eventlabel:breadcrumb.text,
          eventCategory: 'Breadcrumbs Links'
        })"
      >
        <template v-if="breadcrumbLast(breadcrumbs) !== i">
          <slot name="link" v-bind="{ breadcrumb }">
            <SfLink
              class="sf-breadcrumbs__breadcrumb"
              :link="breadcrumb.link"
            >
              {{ breadcrumb.text }}
            </SfLink>
          </slot>
        </template>
        <template v-else>
          <slot name="current" v-bind="{ breadcrumb }">
            <SfLink
              :link="breadcrumb.link"
              class="sf-breadcrumbs__breadcrumb current"
            >
              {{ breadcrumb.text }}
            </SfLink>
          </slot>
        </template>
      </li>
    </ol>
  </nav>
</template>
<script>
import SfLink from "@storefront-ui/vue/src/components/atoms/SfLink/SfLink.vue";
import { useGtm } from '~/composables';

export default {
  name: "SfBreadcrumbs",
  components: {
    SfLink
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { eventCustomlinksInteracted } = useGtm();
    const breadcrumbLast = (breadcrumbs) => {
      return breadcrumbs.length - 1;
    };

    return {
      breadcrumbLast,
      eventCustomlinksInteracted
    };
  },
};
</script>
<style lang="scss">
@import "@storefront-ui/shared/styles/components/atoms/SfBreadcrumbs.scss";
</style>
